/* eslint-disable no-console */
import Notification from 'components/Notification';
import { CONSTANTS, SOCKET_CONST } from 'enum';
import { CLEAR_DATA } from '../common-action-types';
import * as ACTION_TYPES from './action-types';
import { WS_CONNECTED, WS_DISCONNECTED } from '../global/action-types';
import { GENERATE_IMAGE_SUCCESS } from '../objects/action-types';

export const WS_URL = process.env.REACT_APP_WS_URL;

let webSocket;

const closeWebSocket = () => {
  if (webSocket) {
    webSocket.close();
    webSocket = null;
  }
};

const handleSocketMessage = (dispatch, msg) => {
  if (msg.Topic !== SOCKET_CONST.IMAGE_GENERATED) {
    return;
  }

  const storeGateway = JSON.parse(localStorage.getItem(msg.Payload.uuid));
  storeGateway[msg.Payload.platform] = {
    ...storeGateway[msg.Payload.platform],
    token: msg.Payload.token,
    url: msg.Payload.url,
    updatedAt: new Date(),
  };

  if (msg.Payload.url) {
    Notification({
      message: `${storeGateway[msg.Payload.platform].label} is ready to download from ${storeGateway.name}`,
    });
  }

  localStorage.setItem(msg.Payload.uuid, JSON.stringify(storeGateway));
  dispatch({ type: GENERATE_IMAGE_SUCCESS, payload: msg.Payload });
};

const connectWebSocket = (dispatch, getState) => {
  const {
    auth: { isAuthenticated },
    global: { wsConnected },
  } = getState();

  if (wsConnected || !isAuthenticated || webSocket || !WS_URL || typeof WebSocket === 'undefined') {
    return;
  }

  const accessToken = localStorage.getItem(CONSTANTS.LOCAL_ACCESS_TOKEN_KEY);
  if (!accessToken) {
    return;
  }

  webSocket = new WebSocket(`${WS_URL}?token=${accessToken}`);
  dispatch({ type: WS_CONNECTED });

  webSocket.onopen = () => {
    console.log('WS: On Open');
  };
  webSocket.onclose = () => {
    console.log('WS: onClose');
    webSocket = null;
    dispatch({ type: WS_DISCONNECTED });
  };
  webSocket.onerror = (error) => {
    console.log(`WS: WebSocket error ${error}`);
  };
  webSocket.onmessage = ({ data }) => {
    try {
      handleSocketMessage(dispatch, JSON.parse(data));
    } catch (error) {
      console.log(error);
      closeWebSocket();
      dispatch({ type: WS_DISCONNECTED });
    }
  };
};

export function loginStarted() {
  return {
    type: ACTION_TYPES.LOGIN_REQUEST,
  };
}

export function loginSuccess(token) {
  return {
    type: ACTION_TYPES.LOGIN_SUCCESS,
    payload: token,
  };
}

export function loginFailed(err) {
  return {
    type: ACTION_TYPES.LOGIN_FAILURE,
    payload: err,
  };
}

export function logoutUser() {
  closeWebSocket();
  return {
    type: ACTION_TYPES.LOGOUT_USER,
  };
}

export function renewToken() {
  return (dispatch, getState) => {
    dispatch({ type: ACTION_TYPES.RENEW_TOKEN });
    connectWebSocket(dispatch, getState);
  };
}

export function clearData() {
  return {
    type: CLEAR_DATA,
  };
}

export function cleanLoginMessage() {
  return {
    type: ACTION_TYPES.CLEAR_LOG_IN_MESSAGE,
  };
}
